import { Location } from "gen/company/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

import { encodeQueryParam } from "hooks/filters/useWebFilter"

const BASE_DELIVERIES_PATH = "/pos/deliveries"

export function deliveriesCalendar(location?: Location): WebUrl {
  const pathname = `${BASE_DELIVERIES_PATH}/calendar`
  if (!location) return { pathname }

  return {
    pathname,
    query: {
      locations: encodeQueryParam(
        {
          key: UUID.idString(location.id),
          value: location.name,
        },
        true
      ),
    },
  }
}

export function deliveriesList(location?: Location): WebUrl {
  const pathname = `${BASE_DELIVERIES_PATH}/list`
  if (!location) return { pathname }

  return {
    pathname,
    query: {
      locations: encodeQueryParam(
        {
          key: UUID.idString(location.id),
          value: location.name,
        },
        true
      ),
    },
  }
}

export function delivery(id?: PBUUID): WebUrl {
  return {
    pathname: `${BASE_DELIVERIES_PATH}/${UUID.idString(id)}`,
  }
}
